import {
  Baggage,
} from '@dapi/sdk';
import {
  RecursivePartial,
} from '@dapi/sdk/spec';

export const addedBaggageTemplate: RecursivePartial<Baggage> = {
  acceptanceStatus: 'fullyAccepted',
  bagTagPrintStatus: 'printingRequired',
  status: 'inactive'
};
